import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { useMask } from "@react-input/mask";
import { toast } from "react-hot-toast";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import { AddAntrepoRequest } from "../../../models/request/antrepo/AddAntrepoRequest";
import { AntrepoService } from "../../../services/AntrepoService";
import { AddAntrepoResponse } from "../../../models/response/antrepo/AddAntrepoResponse";
import { GetAntrepoByIdResponse, GetAntrepoByIdResponseAntrepoArea, GetAntrepoByIdResponseAntrepoShelf } from "../../../models/response/antrepo/GetAntrepoByIdResponse";
import PageHeader from "../../../components/PageHeader";
import GeneralInformation from "./Components/GeneralInformation";
import AreaInformation from "./Components/AreaInformation";
import ShelfInformation from "./Components/ShelfInformation";
import { Helpers } from "../../../helpers/Helpers";

const AntrepoAdd = () => {
    const navigate = useNavigate();
    const pageName = "Antrepo Modülü > Tanımlamalar > Antrepo Tanımlama"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const generalInformationRef: any = useRef();
    const areaRef: any = useRef();
    const shelfRef: any = useRef();

    const [antrepoId, setAntrepoId] = useState<string | undefined>(undefined);
    const [code, setCode] = useState<string | undefined>(undefined);
    const [phone1, setPhone1] = useState<string | undefined>(undefined);
    const phone1Ref = useMask({ mask: '(___) ___-__-__', replacement: { _: /\d/ } });
    const [palletCapacity, setPalletCapacity] = useState<string | undefined>(undefined);
    const [selectedBaseAntrepo, setSelectedBaseAntrepo] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [email, setEmail] = useState<string | undefined>(undefined);
    const [volumeCapacity, setVolumeCapacity] = useState<string | undefined>(undefined);
    const [selectedAntrepoType, setSelectedAntrepoType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [isCustomActive, setIsCustomActive] = useState<boolean | undefined>(true);

    const [antrepoAreas, setAntrepoAreas] = useState<GetAntrepoByIdResponseAntrepoArea[]>([]);
    const [antrepoShelfs, setAntrepoShelfs] = useState<GetAntrepoByIdResponseAntrepoShelf[]>([]);



    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetAntrepoByIdResponse = await AntrepoService.getAntrepoById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setAntrepoId(response.data.antrepoId);
                setCode(response.data.code);
                setPhone1(response.data.phone1);
                setPalletCapacity(response.data.palletCapacity?.toFixed(2));

                if (response.data.baseAntrepoId && response.data.baseAntrepoName && response.data.baseAntrepoCode)
                    setSelectedBaseAntrepo({ label: response.data.baseAntrepoCode + " - " + response.data.baseAntrepoName, value: response.data.baseAntrepoId })

                setEmail(response.data.email);

                setVolumeCapacity(response.data.volumeCapacity?.toFixed(2))

                if (response.data.antrepoTypeId && response.data.antrepoTypeName)
                    setSelectedAntrepoType({ label: response.data.antrepoTypeName, value: response.data.antrepoTypeId })

                setIsCustomActive(response.data.isCustomActive);

                setAntrepoAreas(response.data.antrepoAreas);
                setAntrepoShelfs(response.data.antrepoShelfs);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const saveAntrepo = async () => {
        try {
            if (!selectedBaseAntrepo)
                toast.error('Antrepo alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var obj: AddAntrepoRequest = {
                    antrepoId: antrepoId,
                    antrepoTypeId: selectedAntrepoType?.value,
                    baseAntrepoId: selectedBaseAntrepo?.value,
                    code: code,
                    email: email,
                    isCustomActive: isCustomActive ? 1 : 0,
                    palletCapacity: palletCapacity,
                    phone1: phone1,
                    volumeCapacity: volumeCapacity,
                    antrepoAreas: antrepoAreas.map(function (x) {
                        return {
                            antrepoAreaTypeId: x.antrepoAreaTypeId,
                            isCustomActive: x.isCustomActive ? 1 : 0,
                            name: x.name
                        }
                    }),
                    antrepoShelfs: antrepoShelfs.map(function (x) {
                        return {
                            address: x.address,
                            antrepoShelfTypeId: x.antrepoShelfTypeId,
                            column: x.column,
                            corridor: x.corridor,
                            floor: x.floor,
                            isCustomActive: x.isCustomActive ? 1 : 0,
                            level: x.level
                        }
                    })
                }

                var response: AddAntrepoResponse = await AntrepoService.addAntrepo(obj);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <PageHeader
                        items={[
                            { text: 'Genel Bilgiler', ref: generalInformationRef },
                            { text: 'Antrepo Alan Bilgileri', ref: areaRef },
                            { text: 'Antrepo Raf Bilgileri', ref: shelfRef },
                        ]}
                    />

                    <GeneralInformation
                        code={code}
                        email={email}
                        generalInformationRef={generalInformationRef}
                        isCustomActive={isCustomActive}
                        palletCapacity={palletCapacity}
                        phone1={phone1}
                        phone1Ref={phone1Ref}
                        selectedAntrepoType={selectedAntrepoType}
                        selectedBaseAntrepo={selectedBaseAntrepo}
                        setCode={setCode}
                        setEmail={setEmail}
                        setIsCustomActive={setIsCustomActive}
                        setPalletCapacity={setPalletCapacity}
                        setPhone1={setPhone1}
                        setSelectedAntrepoType={setSelectedAntrepoType}
                        setSelectedBaseAntrepo={setSelectedBaseAntrepo}
                        setVolumeCapacity={setVolumeCapacity}
                        volumeCapacity={volumeCapacity}
                    />

                    <AreaInformation
                        antrepoAreas={antrepoAreas}
                        areaRef={areaRef}
                        setAntrepoAreas={setAntrepoAreas}
                    />

                    <ShelfInformation
                        antrepoShelfs={antrepoShelfs}
                        setAntrepoShelfs={setAntrepoShelfs}
                        shelfRef={shelfRef}
                    />

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveAntrepo}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment >
    )
}

export default AntrepoAdd;